import StaticPageHeader from "../../Common/StaticPageHeader";
// import homeIcon from "../../../public/home.svg";
import { Link } from "react-router-dom";

const AboutUs = () => {
  return (
    <>
      <StaticPageHeader />
      <div className="container my-3 ">
        <div className="my-4">
          <span className="d-flex gap-2 justify-content-start align-items-center fw-bold fs-">
            <Link to="/">
              <img className="me-2 cursor-pointer" src="home.svg" alt="home" />
            </Link>
            &gt; <span className="ms-2">About Us</span>
          </span>
        </div>

        <div className="row">
          <div className="col-12">
            <h2>About Us</h2>
            <p className="lead">Discover our story and passion for quality</p>
          </div>

          <div className="col-md-12">
            <div className="card  border-0">
              <div className="">
                <h4 className="mb-4">Trex Lighting Solutions</h4>

                <p>
                  At Trex Lighting Solutions, we believe lighting is more than
                  just illumination—it’s about performance, safety, and
                  efficiency.
                </p>

                <p>
                  We work closely with businesses, contractors, and project
                  owners to deliver dependable lighting and electrical solutions
                  that stand the test of time. Whether it’s a factory floor, a
                  commercial complex, or an outdoor infrastructure project, our
                  focus remains the same: high-quality products that perform
                  consistently in real-world conditions.
                </p>

                <p>
                  Our core expertise lies in energy-efficient LED lighting,
                  flood lights, high mast lighting systems, and custom lighting
                  setups designed to match specific project requirements. Every
                  product we offer is selected with durability, power
                  efficiency, and long-term cost savings in mind.
                </p>

                <p>
                  What sets us apart is our practical approach. We don’t just
                  supply products—we understand your usage, environment, and
                  goals before recommending the right solution. This helps our
                  clients reduce energy consumption, improve visibility, and
                  create safer, well-lit spaces.
                </p>

                <p>
                  At Trex Lighting Solutions, we aim to build long-term
                  partnerships based on trust, quality, and reliable service.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AboutUs;